interface ActionTypes {
  GET_ENQUIRY_DETAILS_START: string;
  GET_ENQUIRY_DETAILS_SUCCESS: string;
  GET_ENQUIRY_DETAILS_FAILURE: string;
  UPDATE_ENQUIRY_DETAILS_START: string;
  UPDATE_ENQUIRY_DETAILS_SUCCESS: string;
  UPDATE_ENQUIRY_DETAILS_FAILURE: string;
  GET_REFERRAL_DETAILS_START: string;
  GET_REFERRAL_DETAILS_SUCCESS: string;
  GET_REFERRAL_DETAILS_FAILURE: string;
  SET_ENQUIRY_REFERRALS: string;
  DOWNLOAD_COMBINED_PDF_START: string;
  DOWNLOAD_COMBINED_PDF_SUCCESS: string;
  DOWNLOAD_COMBINED_PDF_FAILURE: string;
  DOWNLOAD_COMBINED_ZIP_START: string;
  DOWNLOAD_COMBINED_ZIP_SUCCESS: string;
  DOWNLOAD_COMBINED_ZIP_FAILURE: string;
  DOWNLOAD_PARTIAL_ZIP_START: string;
  DOWNLOAD_PARTIAL_ZIP_SUCCESS: string;
  DOWNLOAD_PARTIAL_ZIP_FAILURE: string;
  VIEW_ATTACHMENT_START: string;
  VIEW_ATTACHMENT_SUCCESS: string;
  VIEW_ATTACHMENT_FAILURE: string;
  DOWNLOAD_ATTACHMENT_START: string;
  DOWNLOAD_ATTACHMENT_SUCCESS: string;
  DOWNLOAD_ATTACHMENT_FAILURE: string;
  SET_PREVIEW_CONTENT: string;
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_START: string;
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS: string;
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE: string;
  EDIT_ENQUIRY_AUTO_RENEW_START: string;
  EDIT_ENQUIRY_AUTO_RENEW_SUCCESS: string;
  EDIT_ENQUIRY_AUTO_RENEW_FAILURE: string;
  EDIT_ENQUIRY_AUTO_RENEW_RESET: string;
  ARCHIVE_ENQUIRY_START: string;
  ARCHIVE_ENQUIRY_SUCCESS: string;
  ARCHIVE_ENQUIRY_FAILURE: string;
  UPLOAD_ATTACHMENT_START: string;
  UPLOAD_ATTACHMENT_SUCCESS: string;
  UPLOAD_ATTACHMENT_FAILURE: string;
  DELETE_ATTACHMENT_START: string;
  DELETE_ATTACHMENT_SUCCESS: string;
  DELETE_ATTACHMENT_FAILURE: string;
  CLEAR_UPLOAD_ATTACHMENT_ERROR: string;
  CLEAR_DELETE_ATTACHMENT_ERROR: string;
  MOVE_ENQUIRY_TEAM_START: string;
  MOVE_ENQUIRY_TEAM_SUCCESS: string;
  MOVE_ENQUIRY_TEAM_FAILURE: string;
  UPDATE_ATTACHMENT_START: string;
  UPDATE_ATTACHMENT_SUCCESS: string;
  UPDATE_ATTACHMENT_FAILURE: string;
  UPDATE_ATTACHMENT_CLEAR: string;
  GET_ENQUIRY_AUTO_RENEW_SERIES_START: string;
  GET_ENQUIRY_AUTO_RENEW_SERIES_SUCCESS: string;
  GET_ENQUIRY_AUTO_RENEW_SERIES_FAILURE: string;
  ADD_EVENT_START: string;
  ADD_EVENT_SUCCESS: string;
  ADD_EVENT_FAILURE: string;
}

export const DetailsPanelActionTypes: ActionTypes = {
  GET_ENQUIRY_DETAILS_START: '@@GET_ENQUIRY_DETAILS_START',
  GET_ENQUIRY_DETAILS_SUCCESS: '@@GET_ENQUIRY_DETAILS_SUCCESS',
  GET_ENQUIRY_DETAILS_FAILURE: '@@GET_ENQUIRY_DETAILS_FAILURE',
  UPDATE_ENQUIRY_DETAILS_START: '@@UPDATE_ENQUIRY_DETAILS_START',
  UPDATE_ENQUIRY_DETAILS_SUCCESS: '@@UPDATE_ENQUIRY_DETAILS_SUCCESS',
  UPDATE_ENQUIRY_DETAILS_FAILURE: '@@UPDATE_ENQUIRY_DETAILS_FAILURE',
  GET_REFERRAL_DETAILS_START: '@@GET_REFERRAL_DETAILS_START',
  GET_REFERRAL_DETAILS_SUCCESS: '@@GET_REFERRAL_DETAILS_SUCCESS',
  GET_REFERRAL_DETAILS_FAILURE: '@@GET_REFERRAL_DETAILS_FAILURE',
  SET_ENQUIRY_REFERRALS: '@@SET_ENQUIRY_REFERRALS',
  DOWNLOAD_COMBINED_PDF_START: '@@DOWNLOAD_COMBINED_PDF_START',
  DOWNLOAD_COMBINED_PDF_SUCCESS: '@@DOWNLOAD_COMBINED_PDF_SUCCESS',
  DOWNLOAD_COMBINED_PDF_FAILURE: '@@DOWNLOAD_COMBINED_PDF_FAILURE',
  DOWNLOAD_COMBINED_ZIP_START: '@@DOWNLOAD_COMBINED_ZIP_START',
  DOWNLOAD_COMBINED_ZIP_SUCCESS: '@@DOWNLOAD_COMBINED_ZIP_SUCCESS',
  DOWNLOAD_COMBINED_ZIP_FAILURE: '@@DOWNLOAD_COMBINED_ZIP_FAILURE',
  DOWNLOAD_PARTIAL_ZIP_START: '@@DOWNLOAD_PARTIAL_ZIP_START',
  DOWNLOAD_PARTIAL_ZIP_SUCCESS: '@@DOWNLOAD_PARTIAL_ZIP_SUCCESS',
  DOWNLOAD_PARTIAL_ZIP_FAILURE: '@@DOWNLOAD_PARTIAL_ZIP_FAILURE',
  VIEW_ATTACHMENT_START: '@@VIEW_ATTACHMENT_START',
  VIEW_ATTACHMENT_SUCCESS: '@@VIEW_ATTACHMENT_SUCCESS',
  VIEW_ATTACHMENT_FAILURE: '@@VIEW_ATTACHMENT_FAILURE',
  DOWNLOAD_ATTACHMENT_START: '@@DOWNLOAD_ATTACHMENT_START',
  DOWNLOAD_ATTACHMENT_SUCCESS: '@@DOWNLOAD_ATTACHMENT_SUCCESS',
  DOWNLOAD_ATTACHMENT_FAILURE: '@@DOWNLOAD_ATTACHMENT_FAILURE',
  SET_PREVIEW_CONTENT: '@@SET_PREVIEW_CONTENT',
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_START:
    '@@GET_ENQUIRY_AUTO_RENEW_PROPERTIES_START',
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS:
    '@@GET_ENQUIRY_AUTO_RENEW_PROPERTIES_SUCCESS',
  GET_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE:
    '@@GET_ENQUIRY_AUTO_RENEW_PROPERTIES_FAILURE',
  EDIT_ENQUIRY_AUTO_RENEW_START: '@@EDIT_ENQUIRY_AUTO_RENEW_START',
  EDIT_ENQUIRY_AUTO_RENEW_SUCCESS: '@@EDIT_ENQUIRY_AUTO_RENEW_SUCCESS',
  EDIT_ENQUIRY_AUTO_RENEW_FAILURE: '@@EDIT_ENQUIRY_AUTO_RENEW_FAILURE',
  EDIT_ENQUIRY_AUTO_RENEW_RESET: '@@EDIT_ENQUIRY_AUTO_RENEW_RESET',
  ARCHIVE_ENQUIRY_START: '@@ARCHIVE_ENQUIRY_START',
  ARCHIVE_ENQUIRY_SUCCESS: '@@ARCHIVE_ENQUIRY_SUCCESS',
  ARCHIVE_ENQUIRY_FAILURE: '@@ARCHIVE_ENQUIRY_FAILURE',
  UPLOAD_ATTACHMENT_START: '@@UPLOAD_ATTACHMENT_START',
  UPLOAD_ATTACHMENT_SUCCESS: '@@UPLOAD_ATTACHMENT_SUCCESS',
  UPLOAD_ATTACHMENT_FAILURE: '@@UPLOAD_ATTACHMENT_FAILURE',
  DELETE_ATTACHMENT_START: '@@DELETE_ATTACHMENT_START',
  DELETE_ATTACHMENT_SUCCESS: '@@DELETE_ATTACHMENT_SUCCESS',
  DELETE_ATTACHMENT_FAILURE: '@@DELETE_ATTACHMENT_FAILURE',
  CLEAR_UPLOAD_ATTACHMENT_ERROR: '@@CLEAR_UPLOAD_ATTACHMENT_ERROR',
  CLEAR_DELETE_ATTACHMENT_ERROR: '@@CLEAR_DELETE_ATTACHMENT_ERROR',
  MOVE_ENQUIRY_TEAM_START: '@@MOVE_ENQUIRY_TEAM_START',
  MOVE_ENQUIRY_TEAM_SUCCESS: '@@MOVE_ENQUIRY_TEAM_SUCCESS',
  MOVE_ENQUIRY_TEAM_FAILURE: '@@MOVE_ENQUIRY_TEAM_FAILURE',
  UPDATE_ATTACHMENT_START: '@@UPDATE_ATTACHMENT_START',
  UPDATE_ATTACHMENT_SUCCESS: '@@UPDATE_ATTACHMENT_SUCCESS',
  UPDATE_ATTACHMENT_FAILURE: '@@UPDATE_ATTACHMENT_FAILURE',
  UPDATE_ATTACHMENT_CLEAR: '@@UPDATE_ATTACHMENT_CLEAR',
  GET_ENQUIRY_AUTO_RENEW_SERIES_START: '@@GET_ENQUIRY_AUTO_RENEW_SERIES_START',
  GET_ENQUIRY_AUTO_RENEW_SERIES_SUCCESS:
    '@@GET_ENQUIRY_AUTO_RENEW_SERIES_SUCCESS',
  GET_ENQUIRY_AUTO_RENEW_SERIES_FAILURE:
    '@@GET_ENQUIRY_AUTO_RENEW_SERIES_FAILURE',
  ADD_EVENT_START: '@@ADD_EVENT_START',
  ADD_EVENT_SUCCESS: '@@ADD_EVENT_SUCCESS',
  ADD_EVENT_FAILURE: '@@ADD_EVENT_FAILURE'
};

export interface PreviewContent {
  type: string;
  title: string;
  content: string;
}

export interface UploadingAttachment {
  enquiryId: number;
  uuid: string;
  assetOwnerId?: number;
}

export interface UploadAttachmentError {
  enquiryId: number;
  uuid: string;
  assetOwnerId?: number;
  error: string;
}

export interface DeleteAttachmentError {
  id: number;
  error: string;
}

export interface DetailsPanelState {
  enquiryDetails?: any;
  enquiryReferrals: any[];
  isLoadingEnquiryDetails?: boolean;
  combinedPDFDownloadURL?: any;
  isDownloadingCombinedPDF?: boolean;
  combinedZIPDownloadData?: any;
  isDownloadingCombinedZIP?: boolean;
  partialZipDownloadData?: any;
  isDownloadingPartialZip?: boolean;
  currentAttachment?: any;
  fetchingAttachment?: boolean;
  enquiryAutoRenewProperties?: any;
  fetchingEnquiryAutoRenewProperties?: boolean;
  enquiryAutoRenew?: any;
  editingEnquiryAutoRenew?: boolean;
  updatingEnquiry?: boolean;
  updateEnquiryError?: string;
  previewContent?: PreviewContent;
  uploadingAttachments: UploadingAttachment[];
  deletingAttachments: number[];
  uploadAttachmentErrors: UploadAttachmentError[];
  deleteAttachmentErrors: DeleteAttachmentError[];
  moveEnquiryTeam?: any;
  isMovingEnquiryTeam?: boolean;
  updateAttachments: any;
  isUpdatingAttachments: boolean;
  enquiryAutoRenewSeries: any[];
  isGettingEnquiryAutoRenewSeries: boolean;
  isArchivingEnquiry: boolean;
  archivedEnquiry: any;
  event?: any;
  isAddingEvent?: boolean;
  eventError?: any;
}
